import {reqNavbarList} from "@/api";

const state = {
    navbarList: [],
    routesList: []
};
const mutations = {
    NAVBARLIST(state, navbarList) {
        state.navbarList = navbarList
    },
    ROUTESLIST(state, routesList) {
        state.routesList = routesList
    }
};
const actions = {
    //通过API里面的接口函数调用，向服务器发送请求获取数据
    async getNavbarList({commit}) {
        let result = await reqNavbarList();
        if(result.code === 0) {
            let res = result.data
            let routesList = [], navbarList = []
            for(let menu of res) {
                let {url, componentPath, name, meta, children} = menu
                routesList.push({
                    url, componentPath, name, meta
                })
                navbarList.push({
                    url, componentPath, name, meta, children
                })
                /*if(menu.children.length > 0) {
                    for(let submenu of menu.children) {
                        let {url, componentPath, name, meta} = submenu
                        routesList.push({
                            url, componentPath, name, meta
                        })
                    }
                }*/
            }
            commit('NAVBARLIST', navbarList)
            commit('ROUTESLIST', routesList)
        }

        /*console.log(result)
        console.log(routesList)*/

    }
};
const getters = {};

export default {
    state,
    mutations,
    actions,
    getters
}
